import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-136">
      <div className="max-w-xl mx-auto" data-id="element-137">
        <p className="text-center text-xs font-black tracking-widest text-brand-orange uppercase mb-3" data-id="element-138">
          Garanzia totale
        </p>
        <h2 className="text-2xl sm:text-3xl font-black text-center text-brand-cream mb-6" data-id="element-139">
          Rischio zero, 7 giorni di prova
        </h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-gold/30 p-6 sm:p-8 rounded-2xl text-center relative overflow-hidden" data-id="element-140">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-141" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-brand-orange/10 rounded-full blur-3xl" data-id="element-142" />

          <ShieldCheckIcon className="w-14 h-14 text-brand-gold mx-auto mb-3 relative z-10" data-id="element-143" />

          <div className="relative z-10 mb-4" data-id="element-144">
            <div className="text-4xl font-black text-brand-gold" data-id="element-145">7 Giorni</div>
          </div>

          <h3 className="text-xl sm:text-2xl font-black text-brand-cream uppercase mb-3 relative z-10 leading-tight" data-id="element-146">
            Recupera il tuo tempo o ti rimborsiamo
          </h3>

          <p className="text-gray-300 text-sm sm:text-base font-medium leading-relaxed relative z-10 mb-5" data-id="element-147">
            Siamo così sicuri dell'efficacia del Sistema Domotica e Smart Home
            Pro che ti offriamo 7 giorni per provarlo senza alcun rischio.
          </p>
          <p className="text-gray-300 text-sm sm:text-base font-medium leading-relaxed relative z-10 mb-5" data-id="element-148">
            Se sfogliando i materiali non trovi almeno{' '}
            <span className="text-brand-gold font-bold" data-id="element-149">
              3 soluzioni tecniche
            </span>{' '}
            che ti fanno risparmiare immediatamente{' '}
            <span className="text-brand-gold font-bold" data-id="element-150">10 ore di lavoro</span>,
            ti restituiremo ogni centesimo.{' '}
            <span className="text-brand-cream font-bold" data-id="element-151">Senza domande.</span>
          </p>

          <p className="text-brand-cream font-bold text-sm sm:text-base relative z-10" data-id="element-152">
            ⭐ +500 Recensioni Verificate
          </p>
        </motion.div>
      </div>
    </section>;
}